import { useFlag } from '@reflag/react-sdk';

import type * as api from '@gitbook/api-client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';

/**
 * Actions when change request has been archived.
 */
export function ChangeRequestOverviewButton(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest;
    screen: NavigationScreenSpaceState;
}) {
    const { space, changeRequest, screen } = props;
    const crScreenFeature = useFlag('CHANGE_REQUESTS_SCREEN');

    if (crScreenFeature.isEnabled) {
        return null;
    }

    return (
        <Button
            kind="blank"
            size="medium"
            leadingIcon={Icon.InfoCircle}
            iconOnly
            active={screen.sideSheet?.type === 'overview'}
            href={{
                screen: {
                    type: 'space',
                    space: space.id,
                    organization: space.organization,
                    changeRequest: changeRequest.number,
                    sideSheet:
                        screen.sideSheet?.type === 'overview'
                            ? undefined
                            : {
                                  type: 'overview',
                              },
                },
            }}
            label="Overview"
            title="Open the overview of this change request"
        />
    );
}
